import { Component, DestroyRef, inject, ChangeDetectionStrategy } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { MatTooltip } from '@angular/material/tooltip';
import { ActivatedRoute, RouterOutlet } from '@angular/router';
import { CenterContentComponent } from '@core/center-content/center-content.component';
import packageJson from '../../../../package.json';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-page-minimum',
  templateUrl: './page-minimum.component.html',
  styleUrls: ['./page-minimum.component.scss'],
  imports: [RouterOutlet, CenterContentComponent, MatTooltip],
  host: { class: 'page' },
})
export class PageMinimumComponent {
  private route = inject(ActivatedRoute);
  private destroyRef = inject(DestroyRef);

  disableOkLink: boolean = false;
  public version: string = packageJson.version;

  constructor() {
    this.route.data.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(data => {
      this.disableOkLink = data.disableOkLink;
    });
  }
}
